import { clsx } from "clsx";
import type { ReactNode } from "react";

type ContainerSize = "narrow" | "default" | "wide";

export type ContainerProps = {
  size?: ContainerSize;
  className?: string;
  children?: ReactNode;
};

const sizeClass: Record<ContainerSize, string> = {
  narrow: "max-w-[820px]",
  default: "max-w-[1360px]",
  wide: "max-w-[1480px]",
};

export function Container({ size = "default", className, children }: ContainerProps) {
  return (
    <div
      className={clsx(
        "mx-auto w-full px-4 sm:px-6 lg:px-10",
        sizeClass[size],
        className,
      )}
    >
      {children}
    </div>
  );
}
